import './styles.scss'

import { ChevronLeftIcon } from '@/components/Icons'

function BackButton(props) {
  const { name, onClick } = props
  return (
    <button
      className="header-menu-drawer__back-button__wrapper"
      type="button"
      onClick={onClick}
    >
      <div className="header-menu-drawer__back-button">
        <span>{name}</span>
        <ChevronLeftIcon />
      </div>
    </button>
  )
}

export default BackButton
